import React from "react";
import { Trash2, Copy, ScanSearch } from "lucide-react";
import OrderedIconActionContextRow from "../../ui/OrderedIconActionContextRow";

export default function SceneGraphObjectContextMenu({
  contextMenuBodyUuid,
  isPhysicsRunning,
  inspectContextMenuTarget,
  handleDuplicateBody,
  handleDeleteBodyObjects,
}) {
  return (
    <>
      <div className="px-2 py-1.5 text-[11px] font-semibold text-gray-400 uppercase tracking-wide">
        Object
      </div>
      <div className="px-2 pb-1.5">
        <OrderedIconActionContextRow
          actions={[
            {
              key: "inspect",
              label: "Inspect",
              icon: <ScanSearch className="w-4 h-4" aria-hidden="true" />,
              onDefaultClick: inspectContextMenuTarget,
            },
            {
              key: "duplicate",
              label: "Duplicate object",
              icon: <Copy className="w-4 h-4" aria-hidden="true" />,
              disabled: isPhysicsRunning,
              disabledByPhysics: isPhysicsRunning,
              onDefaultClick: () => {
                if (isPhysicsRunning || !contextMenuBodyUuid) return;
                handleDuplicateBody(contextMenuBodyUuid, true);
              },
            },
            {
              key: "delete",
              label: "Delete object",
              icon: <Trash2 className="w-4 h-4" aria-hidden="true" />,
              disabled: isPhysicsRunning,
              disabledByPhysics: isPhysicsRunning,
              onDefaultClick: () => {
                if (isPhysicsRunning || !contextMenuBodyUuid) return;
                handleDeleteBodyObjects([contextMenuBodyUuid]);
              },
            },
          ]}
        />
      </div>
    </>
  );
}
